import posthog from 'posthog-js';

// Initialize PostHog (product analytics) for the browser SPA. No-op when
// VITE_POSTHOG_KEY is unset (e.g. local dev), so contributors don't need a
// project key to run the app — mirrors the Sentry setup in ./sentry.ts.
//
// The project API key (phc_...) is browser-safe by design. Baked into the
// bundle at build time by Vite — rebuild after changing.
export function initPostHog(): void {
  const key = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;
  if (!key) return;

  posthog.init(key, {
    api_host: import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com',
    // Pageviews/leaves and autocapture are on by default; PostHog's
    // defaults('2026-01-30') opt into current recommended behavior.
    defaults: '2026-01-30',
  });
}

const enabled = (): boolean => Boolean(import.meta.env.VITE_POSTHOG_PROJECT_TOKEN);

/**
 * Tie subsequent events to a signed-in user. `distinctId` is the stable
 * Supabase auth UUID (not the display name, which can change). Stitches the
 * prior anonymous session to this person. No-op when PostHog is disabled.
 * Called from the auth flow's single identity-load chokepoint
 * (useAppStore.refreshProfile).
 */
export function identifyUser(distinctId: string, properties?: Record<string, unknown>): void {
  if (!enabled()) return;
  posthog.identify(distinctId, properties);
}

/**
 * Detach events from the signed-out user so the next person on a shared
 * browser starts as a fresh anonymous visitor. No-op when PostHog is disabled.
 * Called from useAppStore.signOut.
 */
export function resetUser(): void {
  if (!enabled()) return;
  posthog.reset();
}

export { posthog };
